module.exports = __webpack_public_path__ + "static/media/bg_TN.fb4ebc9e.jpg";